import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {useMicroTooltipControls} from './Tooltip.utils';
import { ControlButtons, ControlTooltip } from '@learningblocks/storybook-components/lib/ProtocolComponents/ControlTooltip';


export class TooltipControls extends Component {

   tooltipStyle = () => {
    let style = {top: '10px', left: '51%', transform: 'translateX(-50%)'};
    if(!this.props.showControls){
      style.top = '-45px';
    }
    if (this.props.isOpen) {
      style.top = '-63px';
    }
    return style;
  };

  render(){
    const {getControlItems} = useMicroTooltipControls();

    return (
      <ControlTooltip
        label={this.props.label}
        showControls={this.props.count > 0}
        tooltipStyle={this.tooltipStyle()}
        >
        <ControlButtons buttonList={getControlItems(this.props)} />
      </ControlTooltip>
    );
  }
}



TooltipControls.propTypes = {
    /**
     * Booolean to set if contols tooltip should be displayed
     */
    showControls: PropTypes.bool,
    /**
     * List of tubes in apparatus with its status.
     */
    /**
     * Boolean to specify if lid Open
     */
    isOpen: PropTypes.bool,
    /**
     * Function to invoke on Clicking config menu
     */
    openShowControlsModal: PropTypes.func,
    /**
     * Function to open/close Lid
     */
    toggleLid: PropTypes.func,
    /**
     * Funciton to eject all tubes
     */
    onEjectTube: PropTypes.func,
    /**
     * Function to eject all rotors
     */
    onEjectRotor: PropTypes.func,
    /**
     * Function to open Balance Solution Modal
     */
    openBalanceModal: PropTypes.func,
  };

  TooltipControls.defaultProps = {
    // showControls: false,
  };
